<div class="pathology-detail-container">
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>{{ "common.loading" | translate }}</p>
  </div>
  <ng-container *ngIf="!isLoading && riskDetails">
    <div class="pathology-header">
      <button class="back-btn" routerLink="/risks" routerLinkActive="active">← {{ "page.risk.button.back" | translate }}</button>
      <div class="header-content">
        <h1>{{ riskDetails.title }}</h1>
      </div>
    </div>

    <!-- Service Requests Carousel -->
    <div class="carousel-section" *ngIf="riskDetails.serviceRequestTemplates.length > 0">
      <app-carousel [items]="riskDetails.serviceRequestTemplates" [itemsPerView]="2">
        <ng-template let-item>
          <div
            class="service-request-chip"
            role="button"
            tabindex="0"
            (click)="openServiceRequest(item.id)"
            (keydown.enter)="openServiceRequest(item.id)"
            (keydown.space)="openServiceRequest(item.id)"
          >
            <!-- Left: Title + Price-->
            <div class="test-card-content">
              <div class="test-card-title">{{ item.title }}</div>

              <div class="price-container">
                <span class="price">
                  {{ item.price.value | minorUnitCurrency: item.price.currency }}
                </span>

                <span *ngIf="item.price.timing" class="subscription-badge">
                  {{ "page.order.timing." + item.price.timing.periodUnit | pluralTranslate: item.price.timing.period | lowercase }}
                </span>
              </div>
            </div>

            <!-- Right: Action-->
            <div class="test-card-action">
              <button
                class="action-btn"
                (click)="onCartClick(item, $event)"
                [disabled]="loadingItems.has(item.id)"
                [matTooltip]="item.id | cartTooltip: isInCart.bind(this) : recentlyAdded | translate"
              >
                <mat-icon>
                  {{ item.id | cartIcon: isInCart.bind(this) : recentlyAdded }}
                </mat-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </app-carousel>
    </div>

    <!-- Knowledge -->
    <div class="pathology-content" *ngIf="riskDetails.knowledge">
      <section class="section" *ngFor="let media of riskDetails.knowledge.medias">
        <h2>{{ media.label }}</h2>
        <p [innerHTML]="media.description"></p>
        <p [innerHTML]="media.content"></p>
      </section>
    </div>

    <!-- Bottom CTA -->
    <div class="bottom-cta">
      <button
        *ngIf="riskDetails.questionnaires.length"
        class="btn-primary-large"
        [routerLink]="['/risks', riskDetails.identifier.value, 'questionnaires', riskDetails.questionnaires[0]]"
        [state]="{ allQuestionnaires: riskDetails.questionnaires }"
      >
        {{ "page.risk.button.start" | translate }} {{ riskDetails.title }}
      </button>
    </div>
  </ng-container>
</div>
